module.exports = __webpack_public_path__ + "img/nvidia.c985e8f9.png";